<template>
  <div class="event glass-element">

    <div class="event-header">
      <img
        v-if="event.event_image.length > 3"
        :src="event.event_image"
        alt=""
      />
      <img v-else src="../../assets/images/logo_dark.png" alt="" />
      <h3>
        <v-icon v-if="event.event_private"
          >mdi-archive-lock-open-outline</v-icon
        >
        {{ event.event_title }}
      </h3>
    </div>
    <div class="event-content">
      <v-row>
        <v-col>
          <v-icon>mdi-home</v-icon> Hosted by
          {{ event.event_host.username }}
        </v-col>
        <v-col>
          <v-icon>mdi-calendar</v-icon>
          <i>From</i> {{ event.event_datetime_start | parseDateTime}}
          <span v-if="event.event_datetime_end">
            <i>to</i> {{ event.event_datetime_end | parseDateTime }}</span
          >
        </v-col>
        <v-col>
          <v-icon>mdi-account-group</v-icon>
          {{ event.event_min_participants }} -
          {{ event.event_max_participants }}
        </v-col>
      </v-row>

      <div class="event-actions-container">
        <v-row class="main-actions">
          <v-col>
            <v-btn @click="eventDetails">Details</v-btn>
            <TinyLoaderLight v-if="invitationLoading" />
            <v-btn
              v-if="
                canJoin() &&
                !invitationLoading
              "
              @click="getIn(event.event_id)"
              ><span v-if="isInvited()"> Accept invitation!</span>
              <span v-else> Get in !</span>
              </v-btn
            >
          </v-col>
        </v-row>
        <v-row class="secondary-actions" v-if="ownProfile.id === event.event_host.id">
          <v-col>
            <v-btn color="primary" dark @click.stop="dialog = true">
              Delete
            </v-btn>
            <v-dialog v-model="dialog" max-width="290">
              <v-card>
                <v-card-title class="text-h5">
                  Are you sure you want to delete this event?
                </v-card-title>

                <v-card-text> This action cannot be undone. </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="green darken-1" text @click="dialog = false">
                    Disagree
                  </v-btn>

                  <v-btn
                    color="green darken-1"
                    text
                    @click="
                      deleteEvent(event);
                      dialog = false;
                    "
                  >
                    Delete {{ event.event_title }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col>
            <v-btn class="yellow-btn" @click="editEvent(event)">Edit</v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TinyLoaderLight from "@/components/atoms/TinyLoaderLight";
import { parseDateTime } from "@/utils";

export default {
  components: { TinyLoaderLight },
  props: ["event"],
  filters: {parseDateTime},
  data() {
    return {
      deleteConfirmation: false,
      invitationLoading: false,
      dialog: null,
    };
  },
  computed: mapState({
    ownProfile: (state) => state.profiles.ownProfile,
  }),
  methods: {
    isInvited() {
      return this.event.invitations.filter((e) => (e.invitee.id == this.ownProfile.id && e.status == "PE")).length > 0;
    },
    canJoin() {
      // User can join if no invitation with status HO or AC is found.
      return this.event.invitations.filter((e) => (e.invitee.id == this.ownProfile.id && (e.status == "AC" || e.status == "HO"))).length == 0;
    },
    async getIn(id) {
      this.invitationLoading = true;
      if (!this.isInvited()) {
      await this.$store.dispatch("createInvitationFromEvent", {
        invitee: this.ownProfile.id,
        inv_event: id,
        status: "AC",
      });
      }
      else {
        let invitation = this.event.invitations.find(e => e.invitee.id == this.ownProfile.id)
        await this.$store.dispatch("updateInvitations", {
          id: invitation.id,
        invitee: this.ownProfile.id,
        inv_event: id,
        status: "AC",
      });
      }

      this.invitationLoading = false;
      this.$store.dispatch("getEvents");
    },
    abbreviate(text) {
      return text.length > 150 ? `${text.slice(0, 147)}...` : text;
    },
    eventDetails() {
      this.$router.push(`/event/details/${this.event.event_slug}`);
    },
    editEvent(event) {
      this.$store.commit("SET_CURRENT_EVENT", event);
      this.$router.push(`/edit_event/${event.event_slug}`);
    },
    async deleteEvent(event) {
      await this.$store.dispatch("deleteEvent", event).then(() => {
        this.$store.dispatch("getMyEvents", event);
        this.$store.dispatch("getEvents", event);
      });
    }
  },
};
</script>
